<template>
  <div class="review">
    <div class="scoreDiv">
      <div class="scoreDiv-left">
        <label>{{$t('translateText.swi.zf')}}</label><br />
      </div>
      <div class="scoreDiv-middle">
        <span>{{ totalGrade }}</span>
      </div>
      <div class="scoreDiv-right">
        <!-- <span>{{$t('translateText.swi.score')}}</span> -->
      </div>
      <div class="scoreDiv-left">
        <label>{{$t('translateText.swi.tmsl')}}:</label><br />
      </div>
        <div class="scoreDiv-middle">
        <span>{{ this.selectedtopic.length }}</span>
      </div>
    </div>
    <div  class="questionListDiv">
      <p class="questionTypeName" v-if="singleQuestionAnswerList.length > 0">{{ $t('translateText.swi.dxt') }}</p>
      <single
        v-for="questionAnswer in singleQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></single>
      <p class="questionTypeName" v-if="multipleQuestionAnswerList.length > 0">{{ $t('translateText.swi.ddxt') }}</p>
      <multiple
        v-for="questionAnswer in multipleQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></multiple>
      <p class="questionTypeName" v-if="judgmentQuestionAnswerList.length > 0">{{ $t('translateText.swi.pdt') }}</p>
      <judgment
        v-for="questionAnswer in judgmentQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></judgment>
      <p class="questionTypeName" v-if="fillBlankQuestionAnswerList.length > 0">{{ $t('translateText.swi.tkt') }}</p>
      <fillBlank
        v-for="questionAnswer in fillBlankQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></fillBlank>
      <p class="questionTypeName" v-if="shortAnswerQuestionAnswerList.length > 0">{{ $t('translateText.swi.jdt') }}</p>
      <shortAnswer
        v-for="questionAnswer in shortAnswerQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></shortAnswer>
      <p class="questionTypeName" v-if="addLabelQuestionAnswerList.length > 0">{{ $t('translateText.swi.tjbz') }}</p>
        <ExperimentAnswer
          v-for="questionAnswer in addLabelQuestionAnswerList"
          :questionAnswerInfo="questionAnswer"
          :key="questionAnswer.iQuestionAnswerId"
          :correctAnswerShow="true"
          :isdisabled="true"
        ></ExperimentAnswer>
      <p class="questionTypeName" v-if="answerLabelQuestionAnswerList.length > 0">{{ $t('translateText.swi.jdbz') }}</p>

      <ExperimentAnswer
        v-for="questionAnswer in answerLabelQuestionAnswerList"
        :questionAnswerInfo="questionAnswer"
        :key="questionAnswer.iQuestionAnswerId"
        :correctAnswerShow="true"
        :isdisabled="true"
      ></ExperimentAnswer>
    </div>
    <div  class="buttonDiv">
      <one-button :color="false" v-on:translatecolor="back" style="margin:10px 20px">{{ $t('translateText.swi.back') }}</one-button>
    </div>
    <!-- <ShowSlide
      ref="labLabel"
      v-if="LabelisShowSlide"
      :slideId="slideArg.slideId"
      :courseFileId="slideArg.courseFileId"
      :userId="slideArg.userId"
      :otherUserId="slideArg.otherUserId"
      :opentions="opentions"
      :questiontype ="questionType"
      :questionId="slideArg.questionId"
      :questionAnswerId ="this.iQuestionAnswerId"
      :p="slideArg.p"
      :compile ="false"
      @back="LabelisShowSlide = !LabelisShowSlide"
    /> -->
    <!-- <div style="height: 10%;display: flex;justify-content: center;">
      <one-button v-if="LabelisShowSlide" :color="false" @click="LabelisShowSlide = !LabelisShowSlide" style="margin:10px 20px">返回</one-button>
    </div> -->
  </div>
</template>
<script>
// const moment = require('moment');
import single from "@/components/Question/Single"; //单选题
import multiple from "@/components/Question/Multiple"; //多选题
import judgment from "@/components/Question/Judgment"; //判断题
import fillBlank from "@/components/Question/FillBlank"; //填空题
import shortAnswer from "@/components/Question/ShortAnswer"; //简答题
import ExperimentAnswer from "@/components/Question/ExperimentAnswer"; //实验题答案
// import answerLabel from "@/components/Question/AnswerLabel"; //实验题-解答标注
//import { getExaminationAnswer,readOverExamination } from "@/utils/api";
// import CryptoJS from "crypto-js";
// import ShowSlide from "@/components/Question/LabQuestion";

export default {
  data() {
    return {
      strRealName: null,
      iScore: 0, //得分
      actualGrade: 0, //实际总分数
      dtSubmitTime: null,
      singleQuestionAnswerList: [],
      multipleQuestionAnswerList: [],
      judgmentQuestionAnswerList: [],
      fillBlankQuestionAnswerList: [],
      shortAnswerQuestionAnswerList: [],
      addLabelQuestionAnswerList: [],
      answerLabelQuestionAnswerList: [],
    //   LabelisShowSlide:false,
      slideArg: {
        //显示切片参数
        slideId: "",
        courseFileId: "",
        userId: "",
        otherUserId: "",
        p: "",
      },
      opentions:[],
      iQuestionAnswerId:"",//题目答案id
      questionType:"",
      selectedtopic:[],
    };
  },
  mounted() {
    // if(this.$route.path == '/courseContent/Resources/Work/UpdateWork/preview' || this.$route.path == '/courseContent/Resources/TestPaper/UpdateTestPaper/preview' ||
    // this.$route.path == '/courseContent/Task/Choosework/preview' || this.$route.path == '/courseContent/Exam/Choosework/preview'){
        // this.selectedtopic = this.$store.state.examinationinfo.listQuestion
        // console.log(this.selectedtopic);
    // }else{
        // this.selectedtopic = JSON.parse(sessionStorage.getItem("AnswerList"))
    // }
    this.selectedtopic = JSON.parse(sessionStorage.getItem("AnswerList"))
    console.log(this.selectedtopic);
    this.selectedtopic.map((item) => {
        switch (item.question.ddQuestionType.iNumber) {
            case 1:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                }
                this.singleQuestionAnswerList.push(info);
                break;
            }            
            case 2:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                }
                this.multipleQuestionAnswerList.push(info);
                break;
            }
            case 3:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                    
                }
                this.judgmentQuestionAnswerList.push(info);
                break;
            }
            case 4:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                    
                }
                this.fillBlankQuestionAnswerList.push(info);
                break;
            }
            case 5:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                    
                }
                this.shortAnswerQuestionAnswerList.push(info);
                break;
            }
            case 6:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing,
                            ddQuestionType:{iNumber:item.question.ddQuestionType.iNumber}
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                    
                }
                this.addLabelQuestionAnswerList.push(info);
                break;
            }
            case 7:{
                let info = {
                    iQuestionAnswerId:item.question.iQuestionId,
                    examinationQuestion:{
                        iScore:item.iScore,
                        question:{
                            strStandardAnswer:item.question.strStandardAnswer,
                            strQuestionInfo:item.question.strQuestionInfo,
                            strQuestionParsing:item.question.strQuestionParsing,
                            ddQuestionType:{iNumber:item.question.ddQuestionType.iNumber}
                        },
                        iQuestionNum:1
                    },
                    strAnswer:item.question.strStandardAnswer,
                    iScore:item.iScore,
                    
                }
                this.answerLabelQuestionAnswerList.push(info);
                break;
            }
            // case 8:{
            //     let info = item.question
            //     this.$set(info,'iScore',item.iScore)
            //     this.singleQuestionAnswerList.push(item);
            //     break;
            // }
        }
    });


 
  },
  methods: {
        // 浏览切片
    // showSlide(questiondetails){
    //         this.questionType = questiondetails.examinationQuestion.question.ddQuestionType.iNumber
    //         let permissions = [];
    //         if(this.questionType == 6){
    //           permissions = [1.6];  
    //         }else if (this.questionType == 7) {
    //           permissions = [1.7];
    //         }

    //         permissions = CryptoJS.enc.Utf8.parse(JSON.stringify(permissions));
    //         let cryptPwd = CryptoJS.AES.encrypt(
    //         permissions,
    //         CryptoJS.enc.Utf8.parse("12345678123456781234567812345678"),
    //         {
    //             mode: CryptoJS.mode.ECB,
    //         }
    //         ).toString();
    //         cryptPwd = encodeURIComponent(cryptPwd);
    //         // this.LabelisShowSlide = true
    //         this.slideArg.slideId = questiondetails.examinationQuestion.question.courseData.iCourseDataId;
    //         this.slideArg.courseFileId = 0;
    //         this.slideArg.userId = this.userinfo.iUserId;
    //         this.slideArg.otherUserId = 0;
    //         this.slideArg.p = cryptPwd;
    //         if(this.questionType == 6){
    //             this.opentions =  JSON.parse(questiondetails.examinationQuestion.question.strQuestionInfo).question;
    //         }else if(this.questionType == 7){
    //             this.opentions = JSON.parse(questiondetails.strAnswer);
    //         }
    //         this.slideArg.questionId = questiondetails.examinationQuestion.question.iQuestionId
    //         this.iQuestionAnswerId = questiondetails.iQuestionAnswerId
    // },
    back() {
      this.$router.go(-1)
      this.$parent.showrouter = !this.$parent.showrouter
      this.$parent.getQuestions()
    },
    review() {
      this.$router.go(-1);
    },
  },
  computed: {
    totalGrade: function () {
      let totalGrade = 0;
      this.singleQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
      this.multipleQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
      this.judgmentQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
      this.fillBlankQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
      this.shortAnswerQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
       this.addLabelQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
       this.answerLabelQuestionAnswerList.map((item) => {
        let grade = parseInt(item.examinationQuestion.iScore);
        totalGrade += grade;
      });
      return totalGrade;
    },
  },
  components: {
    single,
    multiple,
    judgment,
    fillBlank,
    shortAnswer,
    ExperimentAnswer,
    // ShowSlide,

  },
};
</script>
<style lang="stylus" scoped>
.review {
  height: 100%;
  width: 100%;
  padding: 1% 3% 0% 2%;
  text-align: left;
  position: relative;
  overflow: auto;
}

.scoreDiv {
  position: fixed;
  width: 300px;
  top: 240px;
  right: 40px;
  border: 1px solid #dedede;
  border-radius: 5px;
  box-shadow: 0px 0px 10px 0px #b7b7b7;
  background-color: #fff;
  z-index: 1;
}

.scoreDiv-left {
  position: relative;
  width: 40%;
  text-align: center;
  padding: 20px 0;
  float: left;
}

.scoreDiv-left label {
  font-size: 20px;
  font-weight: 600;
  color: #333333;
}

.scoreDiv-left span {
  font-size: 12px;
  line-height: 24px;
  color: #989898;
}

.scoreDiv-middle {
  position: relative;
  width: 35%;
  text-align: center;
  float: left;
  padding-top: 20px;
  border-bottom: solid 3px #2faeb6;
}

.scoreDiv-middle span {
  font-size: 24px;
  font-weight: 600;
  color: #F86B4F;
  line-height: 30px;
}

.scoreDiv-right {
  position: relative;
  width: 25%;
  float: left;
  font-weight: 600;
  padding: 35px 20px 20px 10px;
}

.realNameDiv {
  line-height: 60px;
}

.realNameDiv .realNameDiv-name {
  font-weight: bold;
  color: #333333;
  font-size: 16px;
}

.realNameDiv .realNameDiv-time {
  font-weight: 400;
  color: #333333;
  margin-left: 20px;
}

.questionTypeName {
  font-weight: bold;
  color: #333333;
  line-height: 40px;
}

.buttonDiv {
  text-align: center;
}
</style>